export default __webpack_public_path__ + "static/media/img-guide-mobile-bg@2x.1ca9bd7e.png";